// import React, { useEffect, useState } from "react";
// import { useNavigate } from "react-router-dom";
// import Cookies from "js-cookie";
// import { MdPerson, MdSearch, MdEventNote } from "react-icons/md";
// import doctorService from "../../Services/doctorService";
// import PaginationComponent from "../../components/PaginationComponent";

// const MONTHS = ["Jan","Feb","Mar","Apr","May","Jun","Jul","Aug","Sep","Oct","Nov","Dec"];
// function fmtDate(str) {
//   if (!str) return "—";
//   const d = new Date(str);
//   return `${MONTHS[d.getMonth()]} ${d.getDate()}, ${d.getFullYear()}`;
// }

// export default function Patients() {
//   const navigate = useNavigate();
//   const doctor = JSON.parse(Cookies.get("doctor") || "{}");

//   const [tab, setTab]               = useState("today"); // "today" | "all"
//   const [todayList, setTodayList]   = useState([]);
//   const [allList, setAllList]       = useState([]);
//   const [loading, setLoading]       = useState(true);
//   const [search, setSearch]         = useState("");

//   useEffect(() => {
//     const load = async () => {
//       setLoading(true);
//       try {
//         const [tp, ap] = await Promise.all([
//           doctorService.getTodayPatients(doctor.id),
//           doctorService.getAllPatients(doctor.id),
//         ]);
//         setTodayList(tp.patients || []);
//         setAllList(ap.patients || []);
//       } catch (e) {
//         console.error(e);
//       } finally {
//         setLoading(false);
//       }
//     };
//     load();
//   }, [doctor.id]);

//   const activeList = tab === "today" ? todayList : allList;
//   const filtered = activeList.filter((p) =>
//     p.full_name?.toLowerCase().includes(search.toLowerCase()) ||
//     p.cnic?.includes(search) ||
//     p.contact_number?.includes(search)
//   );

//   const pending = activeList.filter((p) => !p.prescription_id).length;
//   const written = activeList.filter((p) => p.prescription_id).length;
//   const [currentPage, setCurrentPage] = useState(1);
//   const [paginatedData, setPaginatedData] = useState([]);
//   useEffect(() => {
//   setCurrentPage(1);
// }, [search, tab]);

//   return (
//     <div>
//       <div className="mb-5">
//         <h1 className="text-gray-800 text-xl font-semibold">My Patients</h1>
//         <p className="text-gray-400 text-sm mt-0.5">View and manage your assigned patients</p>
//       </div>

//       {/* Stats */}
//       {/* <div className="grid grid-cols-3 gap-4 mb-5">
//         <div className="bg-white border border-gray-100 rounded-xl p-4 shadow-sm">
//           <p className="text-xs text-gray-400 mb-1">{tab === "today" ? "Today" : "All"} Patients</p>
//           <p className="text-2xl font-semibold text-blue-600">{activeList.length}</p>
//         </div>
//         <div className="bg-white border border-gray-100 rounded-xl p-4 shadow-sm">
//           <p className="text-xs text-gray-400 mb-1">Prescription Written</p>
//           <p className="text-2xl font-semibold text-green-600">{written}</p>
//         </div>
//         <div className="bg-white border border-gray-100 rounded-xl p-4 shadow-sm">
//           <p className="text-xs text-gray-400 mb-1">Pending RX</p>
//           <p className="text-2xl font-semibold text-amber-500">{pending}</p>
//         </div>
//       </div> */}

//       {/* Table card */}
//       <div className="bg-white border border-gray-100 rounded-xl shadow-sm overflow-hidden">
//         {/* Toolbar */}
//         <div className="flex flex-wrap items-center justify-between gap-3 px-5 py-4 border-b border-gray-100">
//           {/* Tabs */}
//           <div className="flex items-center gap-1 bg-gray-100 p-1 rounded-lg">
//             {[
//               { key: "today", label: `Today (${todayList.length})` },
//               { key: "all",   label: `All (${allList.length})` },
//             ].map((t) => (
//               <button
//                 key={t.key}
//                 onClick={() => { setTab(t.key); setSearch(""); }}
//                 className={`px-4 py-1.5 rounded-md text-xs font-medium transition-all ${
//                   tab === t.key
//                     ? "bg-white text-gray-800 shadow-sm"
//                     : "text-gray-400 hover:text-gray-600"
//                 }`}
//               >
//                 {t.label}
//               </button>
//             ))}
//           </div>

//           {/* Search */}
//           <div className="flex items-center gap-2 border border-gray-200 rounded-lg px-3 py-2 w-52">
//             <MdSearch size={16} className="text-gray-400" />
//             <input
//               value={search}
//               onChange={(e) => setSearch(e.target.value)}
//               placeholder="Search by name, CNIC..."
//               className="text-xs text-gray-700 outline-none w-full bg-transparent"
//             />
//           </div>
//         </div>

//         {/* Table */}
//         {loading ? (
//           <div className="py-16 text-center text-gray-400 text-sm">Loading...</div>
//         ) : filtered.length === 0 ? (
//           <div className="py-16 text-center">
//             <MdEventNote size={40} className="text-gray-200 mx-auto mb-2" />
//             <p className="text-gray-400 text-sm">No patients found</p>
//           </div>
//         ) : (
//           <div className="overflow-x-auto">
//             <table className="w-full text-sm">
//               <thead>
//                 <tr className="bg-[#225187]">
//                   {["SR","Patient Name","Contact","CNIC","Address","Fee","Date","RX Status","Action"].map((h) => (
//                     <th key={h} className="text-left text-white/80 text-xs font-medium px-4 py-3 whitespace-nowrap">
//                       {h}
//                     </th>
//                   ))}
//                 </tr>
//               </thead>
//               <tbody>
//   {paginatedData.map((p, i) => (
//                   <tr key={p.sale_id} className="border-b border-gray-50 hover:bg-gray-50 transition-colors">
//                     <td className="px-4 py-3 text-gray-400 text-xs">{(currentPage - 1) * 10 + i + 1}</td>
//                     <td className="px-4 py-3">
//                       <div className="flex items-center gap-2">
//                         <div className="w-7 h-7 rounded-full bg-blue-100 flex items-center justify-center flex-shrink-0">
//                           <MdPerson size={14} className="text-blue-600" />
//                         </div>
//                         <span className="font-medium text-gray-700 whitespace-nowrap">{p.full_name}</span>
//                       </div>
//                     </td>
//                     <td className="px-4 py-3 text-gray-500 text-xs whitespace-nowrap">{p.contact_number || "—"}</td>
//                     <td className="px-4 py-3 text-gray-500 text-xs whitespace-nowrap">{p.cnic || "—"}</td>
//                     <td className="px-4 py-3 text-gray-500 text-xs max-w-[160px] truncate">{p.address || "—"}</td>
//                     <td className="px-4 py-3 text-gray-700 font-medium text-xs whitespace-nowrap">Rs. {p.fee}</td>
//                     <td className="px-4 py-3 text-gray-500 text-xs whitespace-nowrap">{fmtDate(p.checkup_date)}</td>
//                     <td className="px-4 py-3">
//                       {p.prescription_id ? (
//                         <span className="text-xs bg-green-100 text-green-700 px-2 py-0.5 rounded-full">Written</span>
//                       ) : (
//                         <span className="text-xs bg-amber-100 text-amber-700 px-2 py-0.5 rounded-full">Pending</span>
//                       )}
//                     </td>
//                     <td className="px-4 py-3">
//                       <button
//                         onClick={() => {console.log("clicked"); navigate(`/patients/${p.sale_id}`)}}
//                         className="text-xs text-blue-600 hover:text-blue-700 font-medium border border-blue-100 hover:border-blue-300 px-3 py-1 rounded-lg transition-all"
//                       >
//                         View
//                       </button>
//                     </td>
//                   </tr>
//                 ))}
//               </tbody>
//             </table>
//             {filtered.length > 0 && (
//   <div className="py-4 flex justify-center">
//     <PaginationComponent
//       filteredData={filtered}
//       currentPage={currentPage}
//       setCurrentPage={setCurrentPage}
//       setPaginatedData={setPaginatedData}
//       itemsPerPage={10}
//     />
//   </div>
// )}
//           </div>
//         )}
//       </div>
//     </div>
//   );
// }
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import Cookies from "js-cookie";
import { MdPerson, MdSearch, MdEventNote, MdChevronLeft, MdChevronRight } from "react-icons/md";
import doctorService from "../../Services/doctorService";

const MONTHS = ["Jan","Feb","Mar","Apr","May","Jun","Jul","Aug","Sep","Oct","Nov","Dec"];
function fmtDate(str) {
  if (!str) return "—";
  const d = new Date(str);
  return `${MONTHS[d.getMonth()]} ${d.getDate()}, ${d.getFullYear()}`;
}

// Remove duplicate rows that share the same sale_id (API sometimes returns dupes from joins)
function dedupeBySaleId(arr) {
  const seen = new Set();
  return arr.filter((p) => {
    if (seen.has(p.sale_id)) return false;
    seen.add(p.sale_id);
    return true;
  });
}

const ROWS_PER_PAGE = 10;

export default function Patients() {
  const navigate = useNavigate();
  const doctor = JSON.parse(Cookies.get("doctor") || "{}");

  const [tab, setTab]                 = useState("today"); // "today" | "all"
  const [todayList, setTodayList]     = useState([]);
  const [allList, setAllList]         = useState([]);
  const [loading, setLoading]         = useState(true);
  const [search, setSearch]           = useState("");
  const [currentPage, setCurrentPage] = useState(1);

  useEffect(() => {
    const load = async () => {
      setLoading(true);
      try {
        const [tp, ap] = await Promise.all([
          doctorService.getTodayPatients(doctor.id),
          doctorService.getAllPatients(doctor.id),
        ]);
        setTodayList(dedupeBySaleId(tp.patients || []));
        setAllList(dedupeBySaleId(ap.patients || []));
      } catch (e) {
        console.error(e);
      } finally {
        setLoading(false);
      }
    };
    load();
  }, [doctor.id]);

  const activeList = tab === "today" ? todayList : allList;
  const filtered = activeList.filter((p) =>
    p.full_name?.toLowerCase().includes(search.toLowerCase()) ||
    p.cnic?.includes(search) ||
    p.contact_number?.includes(search)
  );

  const pending = activeList.filter((p) => !p.prescription_id).length;
  const written = activeList.filter((p) => p.prescription_id).length;

  // Reset to page 1 whenever the tab, search, or underlying list changes
  useEffect(() => {
    setCurrentPage(1);
  }, [tab, search, todayList, allList]);

  // ---- Pagination math ----
  const totalPages = Math.max(1, Math.ceil(filtered.length / ROWS_PER_PAGE));
  const startIndex = (currentPage - 1) * ROWS_PER_PAGE; // page 1 -> 0, page 2 -> 10, page 3 -> 20...
  const paginated = filtered.slice(startIndex, startIndex + ROWS_PER_PAGE);

  const goToPage = (page) => {
    if (page < 1 || page > totalPages) return;
    setCurrentPage(page);
  };

  // Build a compact page-number list (max 5 visible)
  const getPageNumbers = () => {
    const pages = [];
    const maxVisible = 5;
    let start = Math.max(1, currentPage - Math.floor(maxVisible / 2));
    let end = Math.min(totalPages, start + maxVisible - 1);
    if (end - start + 1 < maxVisible) {
      start = Math.max(1, end - maxVisible + 1);
    }
    for (let i = start; i <= end; i++) pages.push(i);
    return pages;
  };
  const pageNumbers = getPageNumbers();

  return (
    <div>
      <div className="mb-5">
        <h1 className="text-gray-800 text-xl font-semibold">My Patients</h1>
        <p className="text-gray-400 text-sm mt-0.5">View and manage your assigned patients</p>
      </div>

      {/* Table card */}
      <div className="bg-white border border-gray-100 rounded-xl shadow-sm overflow-hidden">
        {/* Toolbar */}
        <div className="flex flex-wrap items-center justify-between gap-3 px-5 py-4 border-b border-gray-100">
          {/* Tabs */}
          <div className="flex items-center gap-1 bg-gray-100 p-1 rounded-lg">
            {[
              { key: "today", label: `Today (${todayList.length})` },
              { key: "all",   label: `All (${allList.length})` },
            ].map((t) => (
              <button
                key={t.key}
                onClick={() => { setTab(t.key); setSearch(""); }}
                className={`px-4 py-1.5 rounded-md text-xs font-medium transition-all ${
                  tab === t.key
                    ? "bg-white text-gray-800 shadow-sm"
                    : "text-gray-400 hover:text-gray-600"
                }`}
              >
                {t.label}
              </button>
            ))}
          </div>

          {/* Search */}
          <div className="flex items-center gap-2 border border-gray-200 rounded-lg px-3 py-2 w-52">
            <MdSearch size={16} className="text-gray-400" />
            <input
              value={search}
              onChange={(e) => setSearch(e.target.value)}
              placeholder="Search by name, CNIC..."
              className="text-xs text-gray-700 outline-none w-full bg-transparent"
            />
          </div>
        </div>

        {/* Table */}
        {loading ? (
          <div className="py-16 text-center text-gray-400 text-sm">Loading...</div>
        ) : filtered.length === 0 ? (
          <div className="py-16 text-center">
            <MdEventNote size={40} className="text-gray-200 mx-auto mb-2" />
            <p className="text-gray-400 text-sm">No patients found</p>
          </div>
        ) : (
          <>
            <div className="overflow-x-auto">
              <table className="w-full text-sm">
                <thead>
                  <tr className="bg-[#225187]">
                    {["SR","Patient Name","Contact","CNIC","Address","Fee","Date","RX Status","Action"].map((h) => (
                      <th key={h} className="text-left text-white/80 text-xs font-medium px-4 py-3 whitespace-nowrap">
                        {h}
                      </th>
                    ))}
                  </tr>
                </thead>
                <tbody>
                  {paginated.map((p, i) => (
                    <tr key={p.sale_id} className="border-b border-gray-50 hover:bg-gray-50 transition-colors">
                      <td className="px-4 py-3 text-gray-400 text-xs">{startIndex + i + 1}</td>
                      <td className="px-4 py-3">
                        <div className="flex items-center gap-2">
                          <div className="w-7 h-7 rounded-full bg-blue-100 flex items-center justify-center flex-shrink-0">
                            <MdPerson size={14} className="text-blue-600" />
                          </div>
                          <span className="font-medium text-gray-700 whitespace-nowrap">{p.full_name}</span>
                        </div>
                      </td>
                      <td className="px-4 py-3 text-gray-500 text-xs whitespace-nowrap">{p.contact_number || "—"}</td>
                      <td className="px-4 py-3 text-gray-500 text-xs whitespace-nowrap">{p.cnic || "—"}</td>
                      <td className="px-4 py-3 text-gray-500 text-xs max-w-[160px] truncate">{p.address || "—"}</td>
                      <td className="px-4 py-3 text-gray-700 font-medium text-xs whitespace-nowrap">Rs. {p.fee}</td>
                      <td className="px-4 py-3 text-gray-500 text-xs whitespace-nowrap">{fmtDate(p.checkup_date)}</td>
                      <td className="px-4 py-3">
                        {p.prescription_id ? (
                          <span className="text-xs bg-green-100 text-green-700 px-2 py-0.5 rounded-full">Written</span>
                        ) : (
                          <span className="text-xs bg-amber-100 text-amber-700 px-2 py-0.5 rounded-full">Pending</span>
                        )}
                      </td>
                      <td className="px-4 py-3">
                        <button
                          onClick={() => navigate(`/patients/${p.sale_id}`)}
                          className="text-xs text-blue-600 hover:text-blue-700 font-medium border border-blue-100 hover:border-blue-300 px-3 py-1 rounded-lg transition-all"
                        >
                          View
                        </button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>

            {/* Pagination bar */}
            <div className="flex flex-wrap items-center justify-between gap-3 px-5 py-3 border-t border-gray-100">
              <p className="text-xs text-gray-400">
                Showing {startIndex + 1}–{Math.min(startIndex + ROWS_PER_PAGE, filtered.length)} of {filtered.length}
              </p>
              <div className="flex items-center gap-1">
                <button
                  onClick={() => goToPage(currentPage - 1)}
                  disabled={currentPage === 1}
                  className="w-7 h-7 flex items-center justify-center rounded-md text-gray-400 hover:bg-gray-100 disabled:opacity-40 disabled:hover:bg-transparent transition-colors"
                >
                  <MdChevronLeft size={16} />
                </button>

                {pageNumbers[0] > 1 && (
                  <>
                    <button
                      onClick={() => goToPage(1)}
                      className="w-7 h-7 flex items-center justify-center rounded-md text-xs text-gray-500 hover:bg-gray-100 transition-colors"
                    >
                      1
                    </button>
                    <span className="text-gray-300 text-xs px-0.5">...</span>
                  </>
                )}

                {pageNumbers.map((page) => (
                  <button
                    key={page}
                    onClick={() => goToPage(page)}
                    className={`w-7 h-7 flex items-center justify-center rounded-md text-xs font-medium transition-colors ${
                      currentPage === page
                        ? "bg-[#225187] text-white"
                        : "text-gray-500 hover:bg-gray-100"
                    }`}
                  >
                    {page}
                  </button>
                ))}

                {pageNumbers[pageNumbers.length - 1] < totalPages && (
                  <>
                    <span className="text-gray-300 text-xs px-0.5">...</span>
                    <button
                      onClick={() => goToPage(totalPages)}
                      className="w-7 h-7 flex items-center justify-center rounded-md text-xs text-gray-500 hover:bg-gray-100 transition-colors"
                    >
                      {totalPages}
                    </button>
                  </>
                )}

                <button
                  onClick={() => goToPage(currentPage + 1)}
                  disabled={currentPage === totalPages}
                  className="w-7 h-7 flex items-center justify-center rounded-md text-gray-400 hover:bg-gray-100 disabled:opacity-40 disabled:hover:bg-transparent transition-colors"
                >
                  <MdChevronRight size={16} />
                </button>
              </div>
            </div>
          </>
        )}
      </div>
    </div>
  );
}